import { Controller } from "stimulus"

export default class AdvancedController extends Controller { 

  _controllersCache = []

  connect() {
    this.element[this.identifier] = this
  }

  getController(identifier) {
    if (identifier in this._controllersCache) return this._controllersCache[identifier];
    const otherController = document.querySelector(`[data-controller="${identifier}"]`)[`${identifier}`]
    this._controllersCache[identifier] = otherController
    return otherController
  }

}